import * as React from "react";
import type { SVGProps } from "react";
const SvgIconNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_40_8906)">
      <path
        d="M1.45 7.5 5.89 5.9 7.5 1.45c.17-.46.83-.46 1 0l1.61 4.44 4.44 1.61c.46.17.46.83 0 1l-4.44 1.61-1.61 4.44c-.17.46-.83.46-1 0L5.9 10.11 1.45 8.5c-.46-.17-.46-.83 0-1"
        fill="#FEF4F2"
      />
      <path
        d="M1.45 7.5 5.89 5.9 7.5 1.45c.17-.46.83-.46 1 0l1.61 4.44 4.44 1.61c.46.17.46.83 0 1l-4.44 1.61-1.61 4.44c-.17.46-.83.46-1 0L5.9 10.11 1.45 8.5c-.46-.17-.46-.83 0-1"
        stroke="#EF6144"
        strokeWidth={1.15}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_40_8906">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconNew;
